(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.observatory = {
    attach: function (context, settings) {
      once('observatory', '#observatory-presentation', context).forEach(function (block) {
        let open = $(block).find(".buttons a:first-child");
        let close = $(block).find(".buttons a:last-child");
        $(block).readmore({
          embedCSS: false,
          moreLink: open,
          lessLink: close
        });

      })
    }
  }
})(jQuery, Drupal, once, drupalSettings);
